import React from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import ImagePreview from '../../../core/layout/ImagePreview';

const VocabularyList = (props) => (
  <Table
    fetching={props.fetching}
    pagination={props.pagination}
    onChange={props.onChange}
    columns={[
      {
        label: 'Vocabulary theme',
        path: 'vocabularyTheme',
        render: (value) => value.name,
        width: '300px',
      },
      {
        label: 'Academic plan',
        path: 'academicPlan',
        render: (value) => value.name,
        width: '200px',
      },
      {
        label: 'Text',
        path: 'text',
        sort: true,
        defaultSortOrder: 'ascend',
      },
      {
        label: 'Sentence',
        path: 'sentence',
      },
      {
        label: 'Translate',
        path: 'translate',
      },
      {
        label: 'Actions',
        path: 'action',
        width: '120px',
        render: (cell, row) => {
          return (
            <>
              <ImagePreview src={row.image} />
              <Button icon="edit" onClick={() => browserHistory.push(`/vocabularies/${row.id}`)} />
              {row.deleted ? (
                <Button icon="check" onClick={() => props.onRestore(row)} />
              ) : (
                <Button icon="delete" onClick={() => props.onDisable(row)} />
              )}
            </>
          );
        },
      },
    ]}
    rows={props.vocabularies}
  />
);

VocabularyList.propTypes = {
  vocabularies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      translate: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      sentence: PropTypes.string.isRequired,
      vocabularyTheme: PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
      }).isRequired,
      academicPlan: PropTypes.shape({
        name: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  fetching: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
  onDisable: PropTypes.func.isRequired,
};

export default VocabularyList;
